export const footer = [
  {
    title: "OUR COMPANY",
    text: [
      { list: "Home", link: "/" },
      { list: "About Us", link: "/about" },
      { list: "Services", link: "/services" },
      { list: "Contact", link: "/contact" },
      { list: "Our Gallery", link: "/gallery" },
      { list: "Blog", link: "/blog" },
    ],
  },

  {
    title: "OUR SERVICES",
    text: [
      { list: "Borehole Drilling", link: "/services/borehole-drilling" },
      { list: "Borehole Maintenance", link: "/services/borehole-maintenance" },
      { list: "Site Survey", link: "/services/site-survey" },
      { list: "Pump Installation", link: "/services/pump-installation" },
      { list: "Water Testing and Consultancy", link: "/services/water-testing-consultancy" },
      { list: "Water Storage Solutions", link: "/services/water-storage-solutions" },
      { list: "Construction and Civil Works", link: "/services/construction-and-civil-works" },

    ],
  },
{
  title: "FOLLOW US",
  text: [
    { list: "Facebook", link: "https://www.facebook.com/profile.php?id=61590446234251" },
    { list: "Instagram", link: "https://www.instagram.com/livamsolutions_ltd?igsh=aWZzN3JzZmc3czdi" },
    { list: "Twitter/X", link: "https://twitter.com/livamsolutions" },
    { list: "LinkedIn", link: "https://linkedin.com/company/livamsolutions" },
    { list: "TikTok", link: "https://www.tiktok.com/@livamsolutions_limited?_r=1&_t=ZS-96eQUwHOD5Q" },
    { list: "YouTube", link: "https://www.youtube.com/@LivamSolutionsLtd" },
  ],
},
];